import { UPDATE_TRIGGERS } from 'constants/actions';

export const updateTriggers = triggers => {
  return {
    type: UPDATE_TRIGGERS,
    triggers,
  };
};
